import { createFileRoute } from '@tanstack/react-router'
import RoyaltyPriceRules from 'Admin/components/royaltyPriceRules/RoyaltyPriceRules'

import { Guard } from '../-guard'

export const Route = createFileRoute('/admin/royaltyPriceRules')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <RoyaltyPriceRules />
        </Guard>
    ),
})
